// import logo from './logo.svg';
import './App.css';
import Add from './add'
function App() {
  return (
    <div className="App">
     <Add />
    </div>
  );
}

export default App;
